import React from 'react'


// COMPONENTES PRIME REACT
import { InputText } from 'primereact/inputtext'
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button'


const OverlayPanelTemplate = ({ InputValue, overlayRef, close, overlayContent, dismissable, styles, placeholder = '', disabled }) => {


  return (
    <React.Fragment>
      <div className="p-inputgroup">
        <InputText value={InputValue} disabled placeholder={placeholder} onClick={(e) => overlayRef.current.toggle(e)} />
        <Button icon='pi pi-chevron-down' disabled={disabled} style={{ padding: '0.5rem 0.3rem' }} type="button" onClick={(e) => overlayRef.current.toggle(e)} />
      </div>
      <OverlayPanel ref={overlayRef}   style={styles} showCloseIcon={true} dismissable={false} onHide={close}  >
        {overlayContent}
      </OverlayPanel>

    </React.Fragment>
  )
}

export default OverlayPanelTemplate